import React from 'react';
import EventButton from '../EventButton';
import { MatchEventType } from '../../enums/matchEventType';
import { useSelector } from 'react-redux';
import { selectActiveMatchEvents, selectMatch } from '../../features/match/matchSlice';
import { MatchStatus, noTimeMatchStatuses } from '../../enums/matchStatus';
import Period from '../../enums/period';
import { EventButtonsNoTeamProps } from './EventButtonsNoTeamProps';

const EventButtonsNoTeam: React.FC<EventButtonsNoTeamProps> = (props) => {
  const { matchStatusId } = props;

  const match = useSelector(selectMatch);
  const activeMatchEvents = useSelector(selectActiveMatchEvents);

  let disableExtraTimeButton = false;
  if (match.matchEvents) {
    let periodEvent;
    match.matchEvents.forEach((matchEvent) => {
      if (
        matchEvent.matchEventTypeId === MatchEventType.INJURY_TIME &&
        periodIdMatchStatusIdIsEqual(matchEvent.periodId, match.matchStatusId)
      ) {
        periodEvent = matchEvent;
      }
    });
    if (periodEvent) {
      let skip = false;
      if (activeMatchEvents.length > 0) {
        if (activeMatchEvents.find((activeMatchEvent) => activeMatchEvent.id === periodEvent.id)) {
          skip = true;
        }
      }
      if (!skip) {
        disableExtraTimeButton = true;
      }
    }
    if (!disableExtraTimeButton) {
      if (noTimeMatchStatuses.indexOf(match.matchStatusId) > -1) {
        disableExtraTimeButton = true;
      }
    }
  }

  function periodIdMatchStatusIdIsEqual(periodId: Period, matchStatusId: MatchStatus) {
    if (periodId === Period.BEFORE_MATCH && matchStatusId === MatchStatus.NOT_STARTED) {
      return true;
    } else if (periodId === Period.FIRST_HALF && matchStatusId === MatchStatus.FIRST_HALF) {
      return true;
    } else if (periodId === Period.HALF_TIME && matchStatusId === MatchStatus.HALF_TIME) {
      return true;
    } else if (periodId === Period.SECOND_HALF && matchStatusId === MatchStatus.SECOND_HALF) {
      return true;
    } else if (periodId === Period.PAUSE_BEFORE_EXTRA_TIME && matchStatusId === MatchStatus.PAUSE_BEFORE_EXTRA_TIME) {
      return true;
    } else if (periodId === Period.FIRST_HALF_EXTRA_TIME && matchStatusId === MatchStatus.FIRST_HALF_EXTRA_TIME) {
      return true;
    } else if (periodId === Period.HALF_TIME_EXTRA_TIME && matchStatusId === MatchStatus.HALF_TIME_EXTRA_TIME) {
      return true;
    } else if (periodId === Period.SECOND_HALF_EXTRA_TIME && matchStatusId === MatchStatus.SECOND_HALF_EXTRA_TIME) {
      return true;
    } else if (periodId === Period.PENALTIES_SHOOTOUT && matchStatusId === MatchStatus.PENALTIES) {
      return true;
    }
    return false;
  }

  return (
    <>
      <EventButton matchEventTypeId={MatchEventType.VAR} noText />
      {matchStatusId !== MatchStatus.PENALTIES && (
        <EventButton matchEventTypeId={MatchEventType.INJURY_TIME} disabled={disableExtraTimeButton} />
      )}
    </>
  );
};

export default EventButtonsNoTeam;
